export default function () {
  /**
     * 
    Returns the first element that matches the specified selector within the string.
    @param {string} selector - The selector to match against.
    @returns {Element | null} - The first matching element, or null if no match is found.
    */
  String.prototype.querySelector = function (selector) {
    return this.toDOM().querySelector(selector);
  };

  /**
     * 
    Returns a static (non-live) NodeList of all elements that match the specified selector within the string.
    @param {string} selector - The selector to match against.
    @returns {NodeList} - A static NodeList containing all matching elements.
    */
  String.prototype.querySelectorAll = function (selector) {
    return this.toDOM().querySelectorAll(selector);
  };

  /**
     * 
    Converts the string to a Document Object Model (DOM) representation.
    @returns {Document} - The Document object representing the DOM structure of the string.
    */
  String.prototype.toDOM = function () {
    const parser = new DOMParser();
    return parser.parseFromString(this, "text/html");
  };
}
